import { ApiClient } from '@carpenter/utils';

export const apiClient = new ApiClient();
